import { inject, Injectable } from '@angular/core';
import { UtilityService } from '@Services/utility.service';
import { TableFieldsDictionaryComponent } from './table-fields-dictionary.component';

@Injectable({
  providedIn: 'root',
})
export class TableFieldsDictionaryModalService {
  readonly uS = inject(UtilityService);

  openTableFieldsDictionaryModal() {
    this.uS
      .pageToModalOpener(TableFieldsDictionaryComponent, 'Dictionary', {}, null, {
        width: '90%',
        height: '90%',
      })
      .subscribe((res) => {});
  }
}
